export default __webpack_public_path__ + "static/media/jahresgespraech-2024.032f6db6.webp";